@if (config) {
  <div class="image-highlight">
    <div class="chart">
      <img [src]="config.metadata['url']" />
    </div>
  </div>
}